import { render, staticRenderFns } from "./SkillHistoryByStudent.vue?vue&type=template&id=6084d2fa&scoped=true"
import script from "./SkillHistoryByStudent.vue?vue&type=script&lang=js"
export * from "./SkillHistoryByStudent.vue?vue&type=script&lang=js"
import style0 from "./SkillHistoryByStudent.vue?vue&type=style&index=0&id=6084d2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6084d2fa",
  null
  
)

export default component.exports